<script setup lang="ts">
interface Props {
  author: ProductReview['extensions']['customerInfo']['name'];
  body: ProductReview['content'];
  publishedDate: ProductReview['createdAt'];
  rating?: ProductReview['points'];
  images?: ProductReviewImages;
}

const { author, body, publishedDate, rating = 0, images = [] } = defineProps<Props>()

const hasImages = computed(() => !!images.length)

const localePublishedDate = useLocaleDate(new Date(publishedDate))
</script>

<template>
  <div class="border-b border-gray-400 mb-[15px]">
    <div class="flex pb-[15px]">
      <div class="flex-auto">
        <span class="block text-primary text-16 font-medium capitalize">#{{ author }}</span>
        <span>{{ localePublishedDate }}</span>
      </div>
      <IconRating :rating="rating" class="text-18" />
    </div>
    <p class="pb-[9.5px] break-words">
      {{ body }}
    </p>
    <div v-if="hasImages" class="flex flex-row gap-[8px] pb-[9.5px]">
      <NuxtLink
        v-for="image of images"
        :key="image.id"
        :to="image.url" 
        :title="image.title"
        class="h-[100px] inline-flex justify-center overflow-hidden border border-secondary"
        data-lightbox
        :data-pswp-width="image.metaData.width"
        :data-pswp-height="image.metaData.height"
        :data-lightbox-caption="body"
      >
        <Img
          :src="image.url"
          :width="image.metaData.width"
          :height="image.metaData.height"
          :alt="image.alt"
          class="max-w-none w-full h-full object-scale-down"
        />
      </NuxtLink>
    </div>
    
  </div>
</template>
